import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase/supabase';

export const useCrossPromotions = (artistId) => {
  const [outgoing, setOutgoing] = useState([]);   // promos this artist runs for others
  const [incoming, setIncoming] = useState([]);   // promos other artists run for this one
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    if (!artistId) { setLoading(false); return; }
    setLoading(true);
    setError(null);
    try {
      const [outRes, inRes] = await Promise.all([
        supabase
          .from('d2f_cross_promotions')
          .select('*, promoted:promoted_artist_id(id, name, slug, genre, avatar_image, cover_image, verified)')
          .eq('promoter_artist_id', artistId)
          .eq('active', true)
          .order('created_at', { ascending: false }),
        supabase
          .from('d2f_cross_promotions')
          .select('*, promoter:promoter_artist_id(id, name, slug, genre, avatar_image, cover_image, verified)')
          .eq('promoted_artist_id', artistId)
          .eq('active', true)
          .order('created_at', { ascending: false }),
      ]);
      setOutgoing(outRes.data || []);
      setIncoming(inRes.data || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [artistId]);

  useEffect(() => { fetch(); }, [fetch]);

  const recordClick = async (promoId, userId) => {
    await supabase.from('d2f_promo_clicks').insert({ promo_id: promoId, user_id: userId || null });
    await supabase.rpc('increment_promo_clicks', { promo_id: promoId }).catch(() => {});
  };

  return { outgoing, incoming, loading, error, refetch: fetch, recordClick };
};